/** Shared by the toolbar's button and toggle so the two controls can't drift apart. */
export const TOOLBAR_CONTROL_CLASS = 'h-auto min-w-13 flex-col gap-1 px-1.5 py-1';
